import React from "react";

// Dynamic Data
const groupA = [
  { sr: 1, code: 101, subject: "Hindi" },
  { sr: 2, code: 102, subject: "English" },
  { sr: 3, code: 103, subject: "Urdu" },
  { sr: 4, code: 104, subject: "Sanskrit" },
  { sr: 5, code: 105, subject: "Bengali" },
  { sr: 6, code: 106, subject: "Punjabi" },
  { sr: 7, code: 107, subject: "Assamese" },
  { sr: 8, code: 108, subject: "Nepali" },
  { sr: 9, code: 109, subject: "Odia" },
  { sr: 10, code: 110, subject: "Kannada" },
  { sr: 11, code: 111, subject: "Malayalam" },
  { sr: 12, code: 112, subject: "Tamil" },
  { sr: 13, code: 113, subject: "Telugu" },
  { sr: 14, code: 114, subject: "Gujarati" },
  { sr: 15, code: 115, subject: "Marathi" },
];

const groupB = [
  { sr: 1, code: 201, subject: "Mathematics" },
  { sr: 2, code: 202, subject: "Science & Technology*" },
  { sr: 3, code: 203, subject: "Social Science" },
  { sr: 4, code: 204, subject: "Economics" },
  { sr: 5, code: 205, subject: "Business Studies" },
  { sr: 6, code: 206, subject: "Home Science & Human Ecology*" },
  { sr: 7, code: 207, subject: "Psychology*" },
  { sr: 8, code: 208, subject: "Indian Culture & Heritage" },
  { sr: 9, code: 209, subject: "Accountancy" },
];

export default function SecondaryProgramme() {
  const bannerStyle = {
    width: "100%",
    height: "400px", // adjust the height as needed
    backgroundImage: 'url("./images/class10.jpeg")', // replace with your image URL
    backgroundSize: "contain",
    backgroundPosition: "center",
  };

  const container = {
    maxWidth: "900px",
    margin: "auto",
    padding: "20px",
    lineHeight: "1.8",
    fontFamily: "Arial, sans-serif",
  };

  const heading = { color: "#1a237e" };

  const tableWrapper = {
    overflowX: "auto", // horizontal scroll if table is too wide
    margin: "20px 0",
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "16px",
    background: "white",
    borderRadius: "8px",
    minWidth: "400px",
  };

  const theadStyle = {
    backgroundColor: "#3949ab",
    color: "#fff",
    textAlign: "left",
  };

  const thtd = {
    padding: "12px 15px",
    borderBottom: "1px solid #ddd",
  };

  return (
    <div>
      <br />
      <br />
      <br />

      <div style={bannerStyle}></div>

      <div style={container}>
        <h2 style={heading}>Secondary Programme</h2>

        <p>
          Secondary Certificate is equivalent to the Xth standard. Eligibility
          for taking admission to Secondary Programme is{" "}
          <strong>minimum 15 years of age (Before Exam)</strong>. There is no
          restriction on choice of subjects and combinations, except that
          minimum one language has to be taken.
        </p>

        <p>
          Learners can choose their subjects from the BOSSE List of Subjects as
          given below:
        </p>

        <h3 style={heading}>Table 1 : List of Subjects for Academic Courses</h3>

        {/* Group A Table */}
        <h4 style={heading}>Group A (Language Subjects)</h4>
        <div style={tableWrapper}>
          <table style={tableStyle}>
            <thead>
              <tr style={theadStyle}>
                <th style={thtd}>SR. NO.</th>
                <th style={thtd}>CODE</th>
                <th style={thtd}>SUBJECT</th>
              </tr>
            </thead>
            <tbody>
              {groupA.map((item, index) => (
                <tr
                  key={item.code}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#f2f3f7" : "white",
                  }}
                >
                  <td style={thtd}>{item.sr}</td>
                  <td style={thtd}>{item.code}</td>
                  <td style={thtd}>{item.subject}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Group B Table */}
        <h4 style={heading}>Group B (Non-Language Subjects)</h4>
        <div style={tableWrapper}>
          <table style={tableStyle}>
            <thead>
              <tr style={theadStyle}>
                <th style={thtd}>SR. NO.</th>
                <th style={thtd}>CODE</th>
                <th style={thtd}>SUBJECT</th>
              </tr>
            </thead>
            <tbody>
              {groupB.map((item, index) => (
                <tr
                  key={item.code}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#f2f3f7" : "white",
                  }}
                >
                  <td style={thtd}>{item.sr}</td>
                  <td style={thtd}>{item.code}</td>
                  <td style={thtd}>{item.subject}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p>
          Learners have to choose <strong>five subjects</strong> with at least
          one and maximum two Language Subjects from Group A and the remaining
          subjects from Group B.
        </p>

        <p>
          Two additional subjects can be taken from either of the two groups
          with additional fees as per BOSSE norms.
        </p>

        <p>Subjects with asterisk (*) have theory as well as practical.</p>
      </div>
    </div>
  );
}
